export default __webpack_public_path__ + "static/media/logo-us-bloomingdales.41164b4b.svg";